import styled from 'styled-components';

export const PdfViewerContainerUI = styled.div`
  width: 100vw;
  height: 100vh;

  gap: 35px;
  background: #002642f2;

  z-index: 5000;

  .close-button {
    font-size: 48px;
    color: white;

    top: 30px;
    right: 30px;

    transform: rotate(45deg);
    font-weight: 400;

    position: absolute;
    z-index: 5001;
    user-select: none;
  }

  position: absolute;
  top: 0;
  left: 0;

  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background: none;
    border: none;

    svg {
      fill: white;
      height: 50px;
    }
  }
`;
